import {Component, Inject, LOCALE_ID, OnInit, ChangeDetectorRef} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { StateService } from '../../../../services/state.service';
import { AppService } from '../../../../services/app.service';
import { UtilitaryService } from '../../../../services/utilitary.service';
import { DroitsService } from '../../../../services/droits.service';
import { DateAdapter, MatSnackBar, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import * as moment from 'moment';

@Component({
  selector: 'upload-file-dialog',
  templateUrl: './upload-file-dialog.component.html',
  styleUrls: ['./upload-file-dialog.component.scss'],
  providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
    //{ provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    {
      provide: MAT_DATE_FORMATS, useValue: {
        parse: {
          dateInput: 'L',
        },
        display: {
          dateInput: 'L',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'L',
          monthYearA11yLabel: 'MMM YYYY',
        },
      }
    },
  ],
})
export class UploadFileDialogComponent implements OnInit {

  config: any = {
    placeholder: 'Commentaire',
    height: '5vh',
    toolbar: [
      ['style', ['bold', 'italic', 'underline']],
      ['para', ['ul', 'ol', 'paragraph', 'height']],
      ['insert', ['table']]
    ],
    disableDragAndDrop: true
  };
  states: any[];
  result: any = {
    documents: [],
    currentEtat: "0",
    archive : 'false',
    selectedDocument: null
  };
  typeDocuments: any = [];
  documents: any = [];
  droits: any = [];
  rights: any[] = [];
  isEditable: boolean = true;
  notUploaded: boolean = true;
  nomDoc: string = "";

  uploadLimit:number=25;
  
  constructor(
    public dialogRef: MatDialogRef<UploadFileDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appService: AppService,
    public stateService: StateService,
    private utilities: UtilitaryService,
    public droitsService: DroitsService,
    private snackbar : MatSnackBar,
	private changeDetectorRef: ChangeDetectorRef,
) { }

  ngOnInit() {
    
	this.appService.upload_limit().subscribe((res) => {
	       if (res.result!=undefined) {
				this.uploadLimit=res.result;
				this.changeDetectorRef.detectChanges();
			}	
	});
	
	
	this.droits = this.data.droits;
    if (this.data.rights!=undefined)
    	this.rights=this.data.rights;
    
    if(this.data.isEditable !== undefined)
      this.isEditable = this.data.isEditable;
    this.utilities.log(this.data);
    if( this.data.document){
      this.result.currentEtat = String(this.data.document.status);
      this.result.archive = String(this.data.document.archive);
    }
    console.log(this.data.documents);
    if(this.data.documents){
      this.typeDocuments = [];
      this.data.documents.forEach((document) => {
        let documentToPush = {...document};
        if(documentToPush.ID == "0"){
			
		 documentToPush.readAndAdd=true;
		 
		 if ( documentToPush.document !=undefined 
				  && documentToPush.document.type !=undefined 
			  && documentToPush.document.type.key !=undefined 
			   && documentToPush.document.type.key
			  && this.rights!=undefined
			  && this.rights[documentToPush.document.type.key]!=undefined
			  && this.rights[documentToPush.document.type.key].w!=undefined	
			  )
			  	documentToPush.readAndAdd=this.rights[documentToPush.document.type.key].w;
		 
			  if ( 
				 documentToPush.readAndAdd
				&& documentToPush.document !=undefined 			  
				  && documentToPush.document.type !=undefined 
			  && documentToPush.document.type.key !=undefined 
			   && documentToPush.document.type.key
			   && this.droits!=undefined
			  && this.droits[documentToPush.document.type.key]!=undefined
			  && this.droits[documentToPush.document.type.key].c!=undefined	
			  )
			documentToPush.readAndAdd=this.droits[documentToPush.document.type.key].c;		
			
			
          this.typeDocuments.push(documentToPush);
          if(this.data.document && document.document.type.key == this.data.document.document.type.key){
            this.result.selectedDocument = documentToPush;
            this.result.selectedDocument.document.parameter = this.data.document.document.parameter;
            this.result.selectedDocument.parameter = this.data.document.parameter;
            this.result.selectedDocument.value = this.data.document.value;
            if(this.result.selectedDocument.value)
            {
              this.result.selectedDocument.value.libelle = this.data.document.libelle;
              this.result.selectedDocument.value.datefin = moment(this.data.document.datefin);
            }
            this.result.selectedDocument.description = this.data.document.description ? this.data.document.description.replace(/<[^>]*>/g, '') : '';
            this.result.selectedDocument.uploaded = true;
            this.notUploaded = false;
            console.log(this.result.selectedDocument, this.data);
          }
        }
      });
      
       console.log("UploadFileDialogComponent",  this.typeDocuments,this.droits);
      
    }
  }

  
  uploadFile(event, documentselected) {
    const element = event[0];
    if(this.checkFileSize(element.size, this.uploadLimit)){
      console.log("fichier inférieur a "+this.uploadLimit+"mo")
      this.result.selectedDocument.wrongsize = false;
      this.appService.uploadDocument(element).subscribe((res) => {
        this.result.selectedDocument.uploaded = true;
        this.notUploaded = false;
        this.result.selectedDocument.value = res;
        this.result.selectedDocument.value.description = this.result.selectedDocument.description;
        this.result.selectedDocument.libelle = this.result.selectedDocument.value.file;
        this.result.selectedDocument.value.libelle = this.result.selectedDocument.value.file;
      });
    }
    else
    {
		let fileZ:any=this.__getFileSie(element.size);
		console.log("fichier supérieur",this.uploadLimit,fileZ);
      this.snackbar.open("Taille de fichier ("+fileZ+"mo) supérieur à "+this.uploadLimit+"mo", "", {
        duration: 5000,
        panelClass: ["error-snackbar"]
      });
    }
  }

  getDocument(document: any) {
    console.log(document);
    //this.isEditable = this.CheckDroitsApplication("document", this.result.selectedDocument, "w");
  }
  
  __getFileSie(fsize: any) {
	const filez = (fsize / 1048576).toFixed(2);
	return filez
  }
  
  checkFileSize(fsize: any, sizelimit) {
    //const file = (fsize / 1048576).toFixed(2);
	let file:any=this.__getFileSie(fsize);
    console.log(fsize, file);
    if(file >= sizelimit)
      return false;
    else
      return true;
  }
}
